import { Scenes } from './Scene';
import { Downloading } from './Downloading';
import { Transitions } from './Transitions';
import { Alert } from './Alert';
import { RatioFormatType } from './RatioFormat';
import { ScenesCreationProgress } from './ScenesCreationProgress';
import { User } from './User';
import { CanvasType } from './Canvas';
import { Effects } from './Effects';
import { CheckoutModal } from './CheckoutModal';
import { UserSongs, Audio } from './Audio';
import { SceneVolume } from './sceneVolume';
import { SettingsState } from 'modules/settings';
import { ReplaceSceneContent } from './ReplaceSceneContent';
import { TemplateState } from './templateTypes';
import { ScenesDownloadingProgress } from './ScenesDownloadingProgress';
import { SidebarState } from 'types/Sidebar';
import { WorkspaceState } from 'types/Clipboard';
import { ShortcutsPopup } from 'modules/shortcutsPopup';
import { ScenesLoader } from 'modules/scenesLoader';
import { StoredProjectFiles } from './ProjectFiles';
import { Filters } from 'modules/filters';
import { Revisions } from 'types/Revision';
import { PersistedSettings } from 'modules/persistedSettings';
import { OneTimePayment } from './UserPaidItems';

export enum ActiveTool {
  None = 'none',
  Transition = 'transition',
  RatioFormat = 'fit',
  PhotoSidebar = 'photoChooser',
  StockVideos = 'stockVideos',
  Text = 'text',
  Font = 'font',
  Color = 'color',
  Audio = 'audio',
  Templates = 'templates',
  Outline = 'outline',
  Shadow = 'shadow'
}

export enum ToolName {
  None = 'none',
  Text = 'text',
  TextPreset = 'text_preset',
  FontCollections = 'font_collections',
  Photo = 'photo',
  Template = 'template',
  Fit = 'fit',
  Trim = 'trim',
  Music = 'music',
  Transition = 'transition',
  Scene = 'scene',
  Timeline = 'timeline',
  SceneFit = 'sceneFit',
  StockVideos = 'stockVideos',
  UndoRedo = 'undo_redo',
  Upload = 'upload',
  Project = 'project'
}

export const mapToolToItem: { [key: string]: ToolName } = {
  [ActiveTool.PhotoSidebar]: ToolName.Photo,
  [ActiveTool.Text]: ToolName.Text,
  [ActiveTool.Audio]: ToolName.Music,
  [ActiveTool.RatioFormat]: ToolName.Fit,
  [ActiveTool.Templates]: ToolName.Template
};

export enum PaidFeatures {
  TextPreset = 'text_preset',
  Font = 'text',
  Audio = 'music',
  PhotoChooser = 'photo',
  Background = 'background', // TODO: I don't know what is it, but sometimes RC has this for image instead of 'photo'
  VideoChooser = 'video',
  ShutterstockPhoto = 'shutterstock_photo',
  ShutterstockVideo = 'shutterstock_video',
  Template = 'template',
  Transition = 'transition',
  Mp4 = 'Mp4',
  Resolution = 'resolution',
  Unsplash = 'unsplash_photo'
}
export enum License {
  Personal = 'personal',
  Commercial = 'commercial'
}

export type AppState = {
  scenes: Scenes;
  downloading: Downloading;
  activeTool: ActiveTool;
  transitions: Transitions;
  alert?: Alert;
  ratioFormat: RatioFormatType;
  user: User | null;
  currentTextId: string[];
  canvas: CanvasType;
  effects: Effects;
  scenesCreationProgress: ScenesCreationProgress;
  scenesDownloadingProgress: ScenesDownloadingProgress;
  audio: Audio;
  userSongs: UserSongs;
  sceneVolume: SceneVolume;
  checkoutModal: CheckoutModal;
  settings: SettingsState;
  replaceSceneContent: ReplaceSceneContent;
  template: TemplateState;
  sidebar: SidebarState;
  workspace: WorkspaceState;
  shortcutsPopup: ShortcutsPopup;
  scenesSources: ScenesLoader;
  projectFiles: StoredProjectFiles;
  filters: Filters;
  revisions: Revisions;
  persistedSettings: PersistedSettings;
  oneTimePayment: OneTimePayment;
};

export type UsedContentItem = {
  type: PaidFeatures;
  id: string;
};
